import React from 'react'

export const SearchIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className='inline-block align-middle h-6 w-6'
    >
      <path
        d='M15.15 15.15l5.6 5.6m-3.9-10.7a6.8 6.8 0 11-13.6 0 6.8 6.8 0 0113.6 0z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></path>
    </svg>
  )
}
